import { gtmConstant } from "../constants/gtmConstant";

export const getStepData = () => {
  const hash = window.location.hash;

  switch (hash) {
    case "#/cards":
      return {
        step_number: 1,
        step_titel: gtmConstant.SecretCode.STEP_TITLE.CARD_SELECTION,
      };

    case "#/pin":
      return {
        step_number: 2,
        step_titel: gtmConstant.SecretCode.STEP_TITLE.DISPLAY_CODE,
      };

    case "#/thank-you":
      return {
        step_number: 3,
        step_titel: gtmConstant.SecretCode.STEP_TITLE.END,
      };

    default:
      return {
        step_number: 0,
        step_titel: gtmConstant.SecretCode.STEP_TITLE.ERROR,
      };
  }
};

export const sendDataLayer = (event, data) => {
    if (window.dataLayer) {
        // Construct the object to push to dataLayer
        const eventData = {
          event, // Event name
          ...data, // Additional data
        };
  
        // Push data to dataLayer
        window.dataLayer.push(eventData);
      } else {
        console.error('dataLayer is not defined. Make sure Google Tag Manager is properly set up.');
      }
}


// WEBPACK FOOTER //
// ./src/actions/gtmService.js